import { ITableConfig } from "@/components/table/table.model";
import { SORTING_DIR } from "@/common/models";
import { Ref, ref } from "@vue/composition-api";

export const table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "menu",
      spanMin: "4rem",
      spanMax: "4rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: true,
    },
    {
      name: "Created At",
      key: "createdAt",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "10rem",
      spanMax: "13rem",
    },
    {
      name: "Created By",
      key: "createdByName",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "10rem",
      spanMax: "1fr",
    },
    {
      name: "Application",
      key: "scope_application",
      sortable: false,
      filterable: false,
      spanMin: "10rem",
      spanMax: "10rem",
    },

    {
      name: "Finding",
      key: "scope_findingTypes",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "10rem",
      spanMax: "1fr",
    },
    {
      name: "Information",
      key: "scope_labelIds",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "10rem",
      spanMax: "1fr",
    },
    {
      name: "Items Count",
      key: "scope_itemsCount",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "10rem",
      spanMax: "1fr",
    },

    {
      name: "Status",
      key: "status",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "10rem",
      spanMax: "14rem",
    },
  ],
};
